export const SN = 'FEEDBACK'
export const SET_CODE = SN + '/SET_CODE'
export const SET_OVERLAY = SN + '/SET_OVERLAY'
